export type TGoldLastPriceResponse = {
  dailyChangePercentage: number;
  price: number;
};

export type TGoldPreorderRequest = {
  amount: string;
  orderType: number;
};

export type TGoldPreorderResponse = {
  amount: number;
  fee: number;
  finalAmount: number;
  marketPrice: number;
  volume: number;
  orderAmount: number;
};

export type TGoldOrderRequest = {
  amount: string;
  orderType: number;
  destinationBankAccount: string | null;
};

export type TUserGoldAssetsResponse = {
  items: TUserGoldAssetsItem[];
  profitAmount: number;
  profitPercentage: number;
  totalValue: number;
};

export type TUserGoldAssetsItem = {
  lastUpdate: string;
  volume: number;
  percent: string;
  profitAmount: number;
  profitPercentage: number;
  title: string;
  value: number;
};

export type TGoldOrderListResponse = {
  result: TGoldOrderResult[];
  totalCount: number;
  pageSize: number;
  pageNumber: number;
};

export type TGoldOrderResult = {
  value: number;
  creationDate: string;
  destinationBank: string;
  destinationBankAccount: string;
  destinationBankLogo: string;
  destinationBankId: number;
  fee: number;
  finalValue: number;
  marketPrice: number;
  orderType: string;
  orderTypeId: GoldOrderTypeEnum;
  status: string;
  statusId: number;
  trackingCode: string;
  volume: number;
  requestedAmount: number;
};

export enum GoldOrderTypeEnum {
  Buy = 1,
  Sell = 2,
}
